"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Elias Vance",
  title: "Master Craftsman | 25 Years Experience",
  bio: "Elias oversees every structural restoration project, applying 25 years of mastery to ensure every roof and siding panel is engineered for lifetime durability.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/sasha_landon_portrait.png"
}, {
  name: "Julian Reed",
  title: "Project Director | 18 Years Experience",
  bio: "Julian bridges the gap between complex architectural plans and on-site execution, specializing in high-performance window systems and custom deck builds.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/marcus_thorne_portrait.png"
}, {
  name: "Sarah Chen",
  title: "Design Consultant | 12 Years Experience",
  bio: "Sarah coordinates the aesthetic and technical aspects of our renovations, ensuring that every energy-efficient solution enhances your home's architectural profile.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/elena_rostova_portrait.png"
}];
export default function TheLeadershipTeam() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}